/* información para el proceso de búsqueda
parámetros: 
{
  "busqueda" : "manual",
  "paginaInicio" : 1,
  "paginaFin" : 10,
  "clasificacion":"",
  "idioma": "es",
  "filtrobusqueda" : "cbusqueda",
  "orderBy" : "ranking",
  "orderbyAscDesc" : "desc",
  "metodoBusqueda": 1
}
Significado de los parameros:
Búsqueda.- Texto a buscar.
 paginaInicio.- Este parámetro funciona en donde quieres iniciar la búsqueda y el número es entero.
 paginaFin.- Este parámetro funciona para traer una cantidad de resultados y el número es entero.
  clasificación. – Se puede utilizar de tres formas: 1.- Se manda vacío “” esto es para que te traiga todos los resultados sin excepciones.
                                                                                        2.- Se manda Anteriores solo trae los documentos de ese filtro.
                                                                                        3.- Se manda Vigentes solo trae los documentos de ese filtro.                                                                                 
 Idioma.- Se puede mandar en (ingles) y es (español).
 Filtrobusqueda.- Es para que busque en un campo,  pueden ser (titulo, temática, descripción y cbusqueda)
 orderBy.- Es para que ordene por un campo,  pueden ser (titulo, temática, descripción y cbusqueda)
 orderbyAscDesc.- Se puede mandar asc (ascendente) y desc (descendente)
 metodoBusqueda.-  Se puede utilizar de 3 formas y el número es entero:
	Se manda 1 para que busque con el and
	Se manda 2 para que busque con el or
	Se manda 3 para que busque con frase exacta
*/
//Default: título, método =2

import React,{useState, useEffect,useRef} from "react";
import normatecaStore from "../../stores/normatecaStore";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "react-headless-accordion";
import Swal from "sweetalert2";
import { DragAndDropService } from "ag-grid-community";

export default function BusquedaAva(){
    const navigate= useNavigate();
    const imgurl= process.env.REACT_APP_IMG_URL;
    const nas= process.env.REACT_APP_NAS;
    const sitio= process.env.REACT_APP_ENV;
    const {menuBusAva,setObtenerMenuBusAva,buscaInputValueAva,
        setCambiaInputValueBuscaAva,
        loading,setObtenerMenuBusAvaEmisor,menuBusAvaEmisor,listaUnidAdminEsp,menuEncabezado} =
    normatecaStore((state) =>( { 
        menuBusAva: state.menuBusAva,
        setObtenerMenuBusAva: state.setObtenerMenuBusAva,
        buscaInputValueAva: state.buscaInputValueAva,
        setCambiaInputValueBuscaAva:state.setCambiaInputValueBuscaAva,
        loading: state.loading,
        setObtenerMenuBusAvaEmisor:state.setObtenerMenuBusAvaEmisor,
        menuBusAvaEmisor: state.menuBusAvaEmisor,
        listaUnidAdminEsp: state.listaUnidAdminEsp,
        menuEncabezado: state.menuEncabezado,
    })); 
     useEffect(() => { 
        let scriptSC1 = document.getElementById("sc1");
        if (document.head.contains(scriptSC1)) {
            scriptSC1.remove();
        }
        let scriptSC2 = document.getElementById("sc2");
        if (document.head.contains(scriptSC2)) {
            scriptSC2.remove();
        }
        
        let script1 = document.createElement("script");
        script1.type = "text/javascript";
        script1.src = sitio==="LOCAL"? "/scripts/typeahead.min.js": "./scripts/typeahead.min.js";
        script1.id="sc1";
        document.head.appendChild(script1);
        let script2 = document.createElement("script");
        script2.type = "text/javascript";
        script2.src = sitio==="LOCAL"? "/scripts/the-basics.min.js" : "./scripts/the-basics.min.js";
        script2.id="sc2";
        document.head.appendChild(script2);

        setObtenerMenuBusAvaEmisor().then(function(data){
            setObtenerMenuBusAva().then(function(data2){
                setUnidAdminEmisor(data[0]?.nombre);
                setUnidAdmin(data2[0]?.nombre);
            }); 
            document.addEventListener("click", clickOutsideUniA, false);
            document.addEventListener("click", clickOutsideEmisor, false);
            return () => {
            document.removeEventListener("click", clickOutsideUniA, false);
            document.removeEventListener("click", clickOutsideEmisor, false);
            };
        });     
     },[]);   
    const uniA = useRef(null);
    const emisor = useRef(null);
    const inputRefBA = useRef(null);
    const [visMenuP,setVisMenuP]=useState(false);
    const [visMenuPE,setVisMenuPE]=useState(false);
    const [unidAdmin, setUnidAdmin] = useState(""); 
    const [unidAdminEmisor, setUnidAdminEmisor] = useState("");
    const [visBusMarNor,setVisBusMarNor] = useState(false);
    const [visBusManual,setVisBusManual] = useState(false);
    const [radOpcBus, setRadOpcBus]= useState(2);
    const [radTipoBus, setRadTipoBus]= useState("titulo");
    const [radMostrar, setRadMostrar]= useState("");
    const [radOrdenDispo, setRadOrdenDispo]= useState("");
    const [radBusAva1, setRadBusAva1]= useState("");
    const [radBusAva2, setRadBusAva2]= useState("");
    const [radBusAva3, setRadBusAva3]= useState("");
    const [radUnidAdmEmisor, setRadUnidAdmEmisor]= useState("");
    const [radManuales, setRadManuales]= useState("");
    const [dirGralAdmon, setDirGralAdmon] = useState("");
    const nasPDF="cat_ntk.pdf";

     const clickOutsideUniA = event => {
        if (uniA.current && !uniA.current.contains(event.target)) {
          setVisMenuP(false);
        }
      };
      const clickOutsideEmisor = event => {
        if (emisor.current && !emisor.current.contains(event.target)) {
          setVisMenuPE(false);
        }
      }; 

    const visualizaMenu=()=>{
        setVisMenuP(!visMenuP);
    }
    const visualizaMenuE=()=>{
        setVisMenuPE(!visMenuPE);
    }
    const visualizaOpc=(valorRd)=>{
        //setRadBusAva(valorRd);
        switch(valorRd){
            case "mn":
                setVisBusManual(false);
                if(radBusAva1==="mn"){
                    setVisBusMarNor(false);
                    setRadBusAva1("");
                }
                else{  
                    setVisBusMarNor(true);
                    setRadBusAva1(valorRd);
                }
                break;
            case "mj":
                setVisBusMarNor(false);
                setVisBusManual(false);
                if(radBusAva2==="mj"){
                    setRadBusAva2("");
                }
                else{  
                    setRadBusAva2(valorRd);
                }
                break;
            case "mm":
                setVisBusMarNor(false);
                if(radBusAva3==="mm"){
                    setVisBusManual(false);
                    setRadBusAva3("");
                }
                else{  
                    setVisBusManual(true);
                    setRadBusAva3(valorRd);
                }
                break;
        }
    }
    const cambiaUnidEmi = (valorUnidEmi)=>{
        setRadUnidAdmEmisor(valorUnidEmi);
        switch(valorUnidEmi){
            case "t":
                setVisMenuP(false);
                setVisMenuPE(false);
                break;
            case "em":
                setVisMenuP(false);
                break;
            case "ua":
                setVisMenuPE(false);
                break;
        }
    } 
    
    const cambiaManual=(valorManual)=>{
        setRadManuales(valorManual);
    }
     const cambiaOpcMenu =(indices)=>{
        let ind = indices.toString().split("-");
        if (ind.length===1){
                setUnidAdmin(menuBusAva[ind[0]].nombre.trim());
                let indl=listaUnidAdminEsp.findIndex((ls)=> ls.substring(5,8)===menuBusAva[ind[0]].id.substring(0,3));
                if(indl>-1){
                    
                    let indm= menuEncabezado[1].nivel2.findIndex((mm)=>mm.idTipo===listaUnidAdminEsp[indl].toString())
                    setDirGralAdmon(menuEncabezado[1].nivel2[indm].nombre);
                }
                else{
                    setDirGralAdmon("");
                }
        }
        visualizaMenu();
    } 
     const cambiaOpcMenuEmisor =(indices)=>{
        let ind = indices.toString().split("-");
        if(ind.length===1){
           setUnidAdminEmisor(menuBusAvaEmisor[ind[0]].nombre.trim());
        }
        visualizaMenuE();
    } 
    const cambiaContenido =(opcM)=>{
        let unidEmi= "";
        let marcoNor= "";
        let marcoJur= "";
        let manuales= "";
        let msj="";
        loading(true);//función de store
        //busqueda - buscaInputValueAva
        //paginaInicio - 1
        //paginaFin - 10
        //clasificacion - radMostrar
        //idioma - "es"
        //filtroBusqueda - "cbusqueda"
        //orderby - radOrdenDispo
        //orderbyAsDes - "desc"
        //metodoBusqueda - radOpcBus
        let buscarDiag= "/";
        let buscaInputValueAvaC= inputRefBA.current.value;
        buscaInputValueAvaC= buscaInputValueAvaC.replace(new RegExp(buscarDiag,"g") ,"|")
        if (buscaInputValueAvaC.trim()==="" && opcM==="bus"){
            msj="No hay elemento de búsqueda \n\n";
        }
        if (radBusAva1=== "mn" && radUnidAdmEmisor===""){
            msj = msj + "Para la opción 'Búsqueda por marco normativo', se debe seleccionar 'Unidad administrativa' o 'Emisor' \n";
        }
        if (radBusAva3=== "mm" && radManuales===""){
            msj = msj + "Para la opción 'Búsqueda por manuales', se debe seleccionar alguno de sus apartados 'Todo', 'Organización' o 'Procedimiento' \n";
        }
        if (msj!=="" && opcM==="bus"){
            loading(false);//función de store
            Swal.fire({//mensaje de 
                title: msj,
                text: "",
                icon: 'info',
                showConfirmButton:false,
                showCancelButton: true,
                // confirmButtonColor: '#3085d6',
                cancelButtonColor: '#0077C8',
                // confirmButtonText: 'Continuar',
                cancelButtonText: 'Cerrar',
                //html: '<div>' + mensajeTem1 + '</div>' + '<div>' + mensajeTem2 + '</div>' + '<div>' + mensajeTem3 + '</div>'
                }).then((result) => {
                if (result.isConfirmed) {
                    return;
                }
            }) 
        }
        else{
            if(radBusAva1==="mn"){
                marcoNor="marco normativo";
                     switch(radUnidAdmEmisor){
                        case "t":
                            unidEmi= "todo";
                        break;
                        case "ua":
                            unidEmi= unidAdmin;
                        break;
                        case "em":
                            unidEmi=unidAdminEmisor;
                        break;
                    } 
            }
            if(radBusAva2==="mj"){
                marcoJur="marco jurídico";
            }
            if(radBusAva3==="mm"){
                let marcoTemp=""
                switch(radManuales){
                    case "t":
                        marcoTemp= "todo";
                    break;
                    case "mo":
                        marcoTemp= "manual organización";
                    break;
                    case "mp":
                        marcoTemp="manual procedimiento";
                    break;
                } 
                manuales= marcoTemp;
            }
            /* switch(radBusAva){
                case "mn"://marco normativo
                    marco="marco normativo";
                     switch(radUnidAdmEmisor){
                        case "t":
                            unidEmi= "todo";
                        break;
                        case "ua":
                            unidEmi= unidAdmin;
                        break;
                        case "em":
                            unidEmi=unidAdminEmisor;
                        break;
                    } 
                break;
                case "mj"://marco jurídico
                    marco="marco jurídico";
                break;
                case "mm"://manuales
                    marco="manual";
                break;
            } */
            if(radMostrar==="" && radOrdenDispo==="" && radOpcBus === 2 && marcoNor==="" && unidEmi===""  && radUnidAdmEmisor==="" && radTipoBus==="" && marcoJur==="" && manuales===""){
                navigate("/app/normateca/qa=" + buscaInputValueAvaC);

            }
            else{
                navigate("/app/normateca/qa=" + buscaInputValueAvaC + "¬" + radMostrar + "-" + radOrdenDispo + "-" + radOpcBus + "-" + marcoNor + "-" + unidEmi + "-" + radUnidAdmEmisor + "-" + radTipoBus + "-" + marcoJur + "-" + manuales);

            }
            loading(false);//función de store
        }
     }
    const limpiaBusq =()=>{
        setCambiaInputValueBuscaAva("");
        setVisMenuP(false);
        setVisMenuPE(false);
        setUnidAdmin(menuBusAva[0]?.nombre); 
        setUnidAdminEmisor(menuBusAvaEmisor[0]?.nombre); 
        setVisBusMarNor(false);
        setVisBusManual(false);
        setRadOpcBus(2);
        setRadMostrar("");
        setRadOrdenDispo("");
        setRadBusAva1("");
        setRadBusAva2("");
        setRadBusAva3("");
        setRadUnidAdmEmisor("");
        setRadManuales("");
        setRadTipoBus("titulo");
        inputRefBA.current.value="";
    }
   
    return(
        <div className="busAvan">
            <div className="divTit">
                <div className="titpublicRes">Búsqueda Avanzada</div>
                <div className="linepublicRes"></div>
            </div>
            <div className="busAvan2">
                <div><p className="pBusAva">Escribe una palabra o frase de la disposición que estas buscando y selecciona una opción</p></div>
                <div>
                    <div className="input-group" id="the-basics">
                        <input ref={inputRefBA} type="text" id="inputQ" name="inputQ"  className="inputTxtBusAva typeahead" data-lang="in_busqueda" placeholder="Buscar..." maxLength={249}/>
                    </div>
                </div>
                <div><p className="pBusAva">Método de búsqueda</p></div>
                <div className="margin-bottom-05">
                    <input type="radio" value="fc" name="radOB" onChange={()=>setRadOpcBus(3)} checked={radOpcBus === 3} />  Buscar la frase completa<br/>
                    <input type="radio" value="pal" name="radOB" onChange={()=>setRadOpcBus(2)} checked={radOpcBus === 2} />  Buscar al menos una palabra
                </div>
                <div><p className="pBusAva">Opción de búsqueda</p></div>
                <div className="margin-bottom-05">
                    <input type="radio" value="tit" name="radTB" onChange={()=>setRadTipoBus("titulo")} checked={radTipoBus === "titulo"} />  En el título<br/>
                    <input type="radio" value="cont" name="radTB" onChange={()=>setRadTipoBus("cbusqueda")} checked={radTipoBus === "cbusqueda"} />  En el contenido<br/>
                    <input type="radio" value="titcont" name="radTB" onChange={()=>setRadTipoBus("todo")} checked={radTipoBus === "todo"} />  En el título y contenido

                </div>
                <div><p className="pBusAva">Mostrar</p></div>
                <div className="margin-bottom-05">
                    <input type="radio" value="dv" name="radM" onChange={()=>setRadMostrar("vigente")} checked={radMostrar === "vigente"} />  Documentos vigentes<br/>
                    <input type="radio" value="da" name="radM" onChange={()=>setRadMostrar("anterior")} checked={radMostrar === "anterior"} />  Documentos anteriores
                </div>
                <div><p className="pBusAva">Orden de las disposiciones</p></div>
                <div className="margin-bottom-05">
                    <input type="radio" value="pa" name="radOD" onChange={()=>setRadOrdenDispo("titulo")} checked={radOrdenDispo === "titulo"}/>  Por orden alfabético<br/>
                    <input type="radio" value="fp" name="radOD" onChange={()=>setRadOrdenDispo("fechapublicacion")} checked={radOrdenDispo === "fechapublicacion"}/>  Por fecha de publicación
                </div>
                <div><p className="pBusAva">Búsqueda por apartado</p></div>
                <div className="margin-bottom-05">
                    <input type="checkbox" value="mn" name="radBA1" onChange={e=>visualizaOpc(e.target.value)} checked={radBusAva1=== "mn"}/>  Búsqueda por marco normativo
{/*                     <input type="radio" value="mn" name="radBA" onChange={e=>visualizaOpc(e.target.value)} checked={radBusAva=== "mn"}/>  Búsqueda por marco normativo */}
                 </div>
                <div className={visBusMarNor? "padleft-2 display-block margin-bottom-2 height-0":"padleft-2 display-none margin-bottom-2 height-0"}>
                    <Row >
                        <Col sm={3} >
                            <input type="radio" value="em" name="radBAUA" onChange={()=>cambiaUnidEmi("t")} checked={radUnidAdmEmisor === "t"}/>  Todo
                        </Col>
                    </Row>
                    
                    <Row className=" height-1-5rem">
                        <Col sm={3} className="whiteSpace-nowrap">
                            <input type="radio" value="ua" name="radBAUA" onChange={()=>cambiaUnidEmi("ua")} checked={radUnidAdmEmisor === "ua"}/>  Unidad administrativa
                        </Col>
                        <Col sm={6} className={radUnidAdmEmisor==="ua" ? "menuBAva":"menuBAva display-none"} ref={uniA}>
                            <Accordion key={"ua"} className={visMenuP? "divAcoorUnidAd2":"divAcoorUnidAd" } >
                            <AccordionItem key={0}  >
                                <AccordionHeader className="menuUnidAdBus display-flex" onClick={visualizaMenu}>
                                    <div className="width-95">{unidAdmin} </div>
                                    {visMenuP?<div className="inegi-nav-despa alignSelf-center lineH-n"></div>:<div className="inegi-nav-desp alignSelf-center lineH-n"></div>}
                                </AccordionHeader>
                                <AccordionBody className={visMenuP? 'display-contents' : 'display-none'} >
                                    <div className="accordion-body divOpcOdena acoordionScroll" key={"div1"}  >
                                        
                                        {menuBusAva?.map((m,index)=>(
                                            <AccordionItem key={"aci" + index.toString()} >
                                                <div key={"divDF1" + index.toString()} >
                                                    <div className= "accordion-body divOpcOrdenaItem" key={"mi" + index.toString()} onClick={()=>cambiaOpcMenu(index)}>
                                                        {m.nombre}
                                                    </div>
                                                </div>
                                            </AccordionItem>
                                        ))}
                                    </div>
                                </AccordionBody>
                            </AccordionItem>
                            </Accordion>
                        </Col>
                    </Row>
                    <Row >
                        <Col sm={3}>
                            <input type="radio" value="em" name="radBAUA" onChange={()=>cambiaUnidEmi("em")} checked={radUnidAdmEmisor === "em"}/>  Emisor
                        </Col>
                        <Col sm={6} className={radUnidAdmEmisor==="em" ? "menuBAva":"menuBAva display-none"} ref={emisor} >
                            <Accordion key={"em"} id="em" className={visMenuPE? "divAcoorUnidAd2":"divAcoorUnidAd" } >
                                <AccordionItem key={1} id="1">
                                    <AccordionHeader className="menuUnidAdBus display-flex" onClick={visualizaMenuE}>
                                        <div id="emi" className="width-95">{unidAdminEmisor} </div>
                                        {visMenuPE?<div className="inegi-nav-despa alignSelf-center lineH-n"></div>:<div className="inegi-nav-desp alignSelf-center lineH-n"></div>}
                                    </AccordionHeader>
                                    <AccordionBody className=
                                    {visMenuPE? 'display-contents' : 'display-none'}>
                                        <div className="accordion-body divOpcOdena acoordionScroll height-36-2" key={"div1"} id="div1" >
                                            {menuBusAvaEmisor?.map((me,index)=>(
                                                <AccordionItem key={"aciE" + index.toString()}>
                                                    <div id={"divDF1E" + index.toString()} key={"divDF1E" + index.toString()}>
                                                        <div id={"miE" + index.toString()} className= "accordion-body divOpcOrdenaItem" key={"miE" + index.toString()} onClick={()=>cambiaOpcMenuEmisor(index)}>
                                                        {me.nombre}
                                                        </div>
                                                    </div>
                                                </AccordionItem>
                                            ))}
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                                </Accordion>
                        </Col>
                    </Row>
                </div>
                <div className="margin-bottom-05">
                    <input type="checkbox" value="mj" name="radBA2" onChange={e=>visualizaOpc(e.target.value)} checked={ radBusAva2=== "mj"}/>  Búsqueda por marco jurídico
                </div>

                <div className="margin-bottom-05">
                    <input type="checkbox" value="mm" name="radBA3" onChange={e=>visualizaOpc(e.target.value)} checked={radBusAva3=== "mm"}/>  Búsqueda por manuales
                 </div>
                <div className={visBusManual? "padleft-2 display-block margin-bottom-2 height-0":"padleft-2 display-none margin-bottom-2 height-0"}>
                    <Row >
                        <Col sm={3} >
                            <input type="radio" value="mt" name="radBAMT" onChange={()=>cambiaManual("t")} checked={radManuales === "t"}/>  Todo
                        </Col>
                    </Row>
                    <Row >
                        <Col sm={3} >
                            <input type="radio" value="mo" name="radBAMO" onChange={()=>cambiaManual("mo")} checked={radManuales === "mo"}/>  Organización
                        </Col>
                    </Row>
                    <Row >
                        <Col sm={3} >
                            <input type="radio" value="mp" name="radBAMP" onChange={()=>cambiaManual("mp")} checked={radManuales === "mp"}/>  Procedimientos
                        </Col>
                    </Row>
                </div>

                <div className="display-flex">
                    <div><button onClick={limpiaBusq} type="button" className="btnEnviaOpi">Limpiar campos</button></div>
                    <div className="padleft-1"><button onClick={()=>cambiaContenido("bus")} type="button" className="btnEnviaOpi">Buscar</button></div>
{/*                     <div className="width-0 visib-hidden"><a id="aBusAvaOculto" onClick={cambiaValueAvaOpc} >Oculto</a></div>
 */}                </div>
                <div className="padTop-1">
                    <p>Descarga el Catálogo de Disposiciones Vigentes <a href={nas + nasPDF} className="apiepagina padleft-1"  target="_blank"><img src={imgurl + "ico/ico_pdf.png"}  /></a></p>
                </div>
            </div>
        </div>
    )
}